export default __webpack_public_path__ + "static/media/ikonica-off.6f2d831a.png";